import React, { useEffect, useRef, useState } from 'react';
import { Popup, Button, ToggleButton, Pane } from '@leverege/ui-elements';
import classnames from 'classnames';
import S from './AlertPopup.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function AlertPopup({
  value: alerts,
  vin,
  alertLabels = {},
  alertVariants = {},
  defaultFirstPillVariant = 'pillError',
  defaultLastPillVariant = 'pillError',
  className,
  style,
  table
}) {
  const [isDialogOpened, setIsDialogOpened] = useState(false);
  const popupRef = useRef();
  const toggleDialogOpened = () => {
    setIsDialogOpened(!isDialogOpened);
  };
  useEffect(() => {
    const element = popupRef.current;
    if (!element) {
      return () => {};
    }
    const stopPropagation = event => {
      event?.stopPropagation();
    };
    element?.addEventListener?.('click', stopPropagation);
    element?.addEventListener?.('dblclick', stopPropagation);
    return () => {
      element?.removeEventListener?.('click', stopPropagation);
      element?.removeEventListener?.('dblclick', stopPropagation);
    };
  }, [isDialogOpened]);
  if (!Array.isArray(alerts) || alerts.length === 0) {
    return null;
  }
  const [firstAlert, ...restOfAlerts] = alerts;
  const renderTrigger = props => {
    const {
      ref
    } = props;
    const firstPillClassName = restOfAlerts.length === 0 ? S.firstPill : S.shrinkableFirstPill;
    return table ? /*#__PURE__*/_jsx(Pane, {
      variant: "tableCellContent",
      children: /*#__PURE__*/_jsxs("div", {
        className: classnames(S.popupTrigger, className),
        style: style,
        ref: ref,
        onClick: event => {
          event.stopPropagation();
          toggleDialogOpened();
        },
        children: [/*#__PURE__*/_jsx(ToggleButton, {
          className: firstPillClassName,
          variant: alertVariants[firstAlert] || defaultFirstPillVariant,
          value: isDialogOpened,
          onChange: toggleDialogOpened,
          children: alertLabels[firstAlert] || firstAlert
        }), restOfAlerts.length ? /*#__PURE__*/_jsxs(ToggleButton, {
          className: S.lastPill,
          variant: defaultLastPillVariant,
          value: isDialogOpened,
          onChange: toggleDialogOpened,
          children: ["+", restOfAlerts.length, " More"]
        }) : null]
      })
    }) : /*#__PURE__*/_jsxs("div", {
      className: classnames(S.popupTrigger, className),
      style: style,
      ref: ref,
      onClick: event => {
        event.stopPropagation();
        toggleDialogOpened();
      },
      children: [/*#__PURE__*/_jsx(ToggleButton, {
        className: firstPillClassName,
        variant: alertVariants[firstAlert] || defaultFirstPillVariant,
        value: isDialogOpened,
        onChange: toggleDialogOpened,
        children: alertLabels[firstAlert] || firstAlert
      }), restOfAlerts.length ? /*#__PURE__*/_jsxs(ToggleButton, {
        className: S.lastPill,
        variant: defaultLastPillVariant,
        value: isDialogOpened,
        onChange: toggleDialogOpened,
        children: ["+", restOfAlerts.length, " More"]
      }) : null]
    });
  };
  return /*#__PURE__*/_jsx(Popup, {
    className: S.popup,
    trigger: renderTrigger,
    opened: isDialogOpened,
    onChange: data => setIsDialogOpened(data.isOpened),
    stopPropagation: true,
    render: onClose => {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          className: S.popupCloseButton,
          variant: "closeDialog",
          onClick: onClose
        }), /*#__PURE__*/_jsxs("div", {
          ref: popupRef,
          children: [/*#__PURE__*/_jsx("div", {
            className: classnames(S.popupHeader, S.selectableText),
            children: vin
          }), /*#__PURE__*/_jsx("div", {
            className: S.popupItemsContainer,
            children: alerts.map(alert => /*#__PURE__*/_jsx("div", {
              className: classnames(S.popupItem, S.selectableText),
              children: alertLabels[alert] || alert
            }, alert))
          })]
        })]
      });
    }
  });
}